import polyglotI18nProvider from 'ra-i18n-polyglot';

import { createAccessibleI18nProvider } from '@sh4res/bo-common/utils/createAccessibleI18nProvider';

import { translationMessages } from '@I18n/index';

const baseI18nProvider = polyglotI18nProvider(
  (locale) => (locale === 'fr' ? translationMessages.fr : translationMessages.en),
  'fr',
  [
    { locale: 'fr', name: 'Français' },
    { locale: 'en', name: 'English' },
  ],
  { enableFallback: true },
);

export const i18nProvider = createAccessibleI18nProvider(baseI18nProvider);
